import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import {getConnectionsForUser} from "../../actions/session";
import {fetchContent} from "../../actions/contentActions";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ViewTitle from "../../components/ViewTitle";
import Grid from "@material-ui/core/Grid";
import history from "../../history";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  paper: {
    maxWidth: 936,
    margin: 'auto',
    overflow: 'hidden',
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  searchInput: {
    fontSize: theme.typography.fontSize,
  },
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
});

class DashboardHome extends React.Component {


  componentDidMount() {
    this.props.getConnectionsForUser(this.props.session.userId);
    this.props.fetchContent("6107606c1efeb19f2334e192");
  }

// <span dangerouslySetInnerHTML={{__html: props.connection.emotionalLink}} />

  renderPageFromDatabase = () => (
    <span dangerouslySetInnerHTML={{__html: this.props.dashboardMessage.data}}/>
  )

  renderDirections = () => (
    <React.Fragment>
      <Typography variant='h5' component='h6' color="textSecondary" align="center">
        Welcome!
      </Typography>
      <br/>
      <Typography variant="body1">
        It’s wonderful to see that you have made it here! It means that you are someone who has expanded your awareness
        to self-healing and empowerment! That is so impressive!
        This is an exclusive access BONUS database that I have made available to you to go along with your training
        course. I want to support you to get the results that you want in your life!
      </Typography>
      <br/>
      <List style={{paddingBottom: "0px" }}>
        <ListItem style={{paddingBottom: "0px" }}>
          <ListItemText style={{paddingBottom: "0px" }}>
            Some quick instructions:
          </ListItemText>
        </ListItem>
      </List>
      <ul>
        <li>Go to the search bar and enter your health issue or ailment.</li>
        <li>Once you find the ailment in the dropdown menu, click on the “+” button to add the selection. This will add
          the information to your profile tab to make it easy for you to refer back to.
        </li>
        <li>If you have any questions, simply email us.</li>
        <li>If your ailment is not (yet) in the database, simply fill out the form.</li>
      </ul>
      <Typography variant="caption">
        Please note: there are over 10k known ailments. If yours is not listed, it does not mean that Brandy has not
        worked with it. It simply means that it has not yet been added. 10k is a lot! With that amount, if we add 5 per
        day, it will take us over 5 years. So, if yours is not here, no worries. Please fill out the form and we can add
        it for you.
      </Typography>
      <List style={{paddingBottom: "0px" }}>
        <ListItem style={{paddingBottom: "0px"}}>
          <ListItemText style={{paddingBottom: "0px"}}>
            Additional Important Notes:
          </ListItemText>
        </ListItem>
      </List>
      <ul>
        <li>PS: I know that most people will only need a few selections from this app. I don’t want you to be
          overwhelmed with the process, for that reason, the software is limited to 6 selections per person to help keep
          you from being overwhelmed. Of course some people have more ailments than this, but the best recommendation is
          to start with just a few and work with just those. Please note that working on too many things at once could
          overwhelm you or trigger you backwards and we want you to get results. After you have worked with your
          selection then, if you personally are experiencing more, simply email our support team and we can assist you.
        </li>
        <li>
          Some people will want to look up ailments of their spouses or someone around them, and instead of healing,
          this will actually reinforce negative patterns. Please make sure not to do this. This is for personal use only
          and could trigger them or keep you from healing.
          <ul>
            <li>For example, let’s say someone has victim issues and they look up their mother’s ailments and read that
              they are connected to anger issues. This will actually reinforce being a victim in the situation by
              putting
              blame on the other person, and prevent the person from getting results.
            </li>
          </ul>
        </li>
        <li>
          As always, if you need assistance we are here to support you. Simply email us at <a href="mailto:support@brandygillmore.com">support@brandygillmore.com</a>
        </li>
      </ul>
    </React.Fragment>
  )
  ;

  render() {
    const {classes} = this.props;
    return (
      <Paper className={classes.paper}>
        <div className={classes.contentWrapper}>
          <ViewTitle>
            Home
          </ViewTitle>
          <>
            {
              // this.props.dashboardMessage ? this.renderPageFromDatabase() : this.renderDirections()
              this.renderDirections()
            }
            <Grid container justify="center">
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => history.push(`/dashboard/query`)}
                  style={{margin: "24px"}}
                >
                  Search Database
                </Button>
              </Grid>
            </Grid>
          </>
        </div>
      </Paper>
    );
  };
}

DashboardHome.propTypes = {
  classes: PropTypes.object.isRequired,
};

DashboardHome = withStyles(styles)(DashboardHome);

const mapStatetoProps = (state) => {
  if (state.content && state.content.content) {
    return {
      ...state,
      dashboardMessage: state.content.content
    }
  } else {
    return {
      ...state
    }
  }
};

DashboardHome = connect(
  mapStatetoProps, {
    getConnectionsForUser,
    fetchContent
  }
)(DashboardHome);


export default DashboardHome;